import template from './form.html';
import { rest } from 'core/api';
import facturasI18N from 'i18n/facturas/es.json';
import { FormActions } from 'core/services/form';
import commonI18N from 'i18n/common/es.json';
import { pad, fechaRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';


export let FacturaFormComponent = {
  templateUrl: template,
  selector: 'facturaAnular',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(facturasI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$filter', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'AuthorizationService', 'BasicFactory', '$timeout', 'localStorageService', 'CustomModal', '$scope', '$resource', 'HeadersUtil'
];

function FormController($state, $filter, $ngRedux, ngNotify, $stateParams, Filter, AuthorizationService, BasicFactory, $timeout, localStorageService, CustomModal, $scope, $resource, HeadersUtil) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);

  this.onSelectTipoComprobante = onSelectTipoComprobante.bind(this);
  this.renderTipoComprobante = renderTipoComprobante.bind(this);
  this.renderCliente = renderCliente.bind(this);

  let unsubscribe;

  const sinNombreFilter = Filter.path('numeroDocumento').like('44444401-7');

  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    $ngRedux.dispatch(rest.actions.clientesValor.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    $ngRedux.dispatch(rest.actions.clientesValor.get({ filter: JSON.stringify(sinNombreFilter) }));
    this.initRedux = true;
    let caja = localStorageService.get('caja');

    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      $timeout(() => $state.go('home.cajas.list'));
      return;
    }

    this.title = this.translations['Anular Factura'];
    this.form();
    if (caja) {
      $ngRedux.dispatch(rest.actions.timbradosVigentes({}, {
        body: JSON.stringify({
          cajaId: caja.id,
          sesionCajaId: caja.sesionActual.id,
          puntoEmisionId: caja.puntoEmision.id,
          tipos: ['Factura']
        })
      }));
    }
  };

  this.localModel = {
    fechaFactura: moment(new Date()).format('DD/MM/YYYY')
  };

  this.opt = {
    fechaOptions: {}
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;

    this.model = state.form.model;

    if (this.initRedux && !this.modelInit &&
      state.timbradosVigentes.data && state.timbradosVigentes.data.length > 0) {
      this.modelInit = true;

      let timbradoDefault = state.timbradosVigentes.data.filter(v => v.tipoComprobanteDefault) || [];
      if (timbradoDefault.length) {
        this.model.timbradoDetalle = timbradoDefault[0];
        this.onSelectTipoComprobante();
      }
      this.model.fechaFactura = this.localModel.fechaFactura;
    }

    if (state.clientesValor.data && state.clientesValor.data.length > 0 && this.model.cliente == undefined) {
      this.model.cliente = state.clientesValor.data[0];
    }

    return {
      form: state.form,
      timbradosVigentes: state.timbradosVigentes.data
    };
  }


  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.timbradosVigentes.error) {
      ngNotify.set(state.timbradosVigentes.error.message, 'error');
      $timeout(() => $state.go('home.cajas.list'));
    }
  }

  function doSubmit() {
    let self = this;
    if ($scope.form.$invalid) {
      this.submitted = true;
      return;
    }

    this.model.numeroComprobante = this.localModel.numeroUno + '-' + this.localModel.numeroDos + '-' + `${pad(this.localModel.numeroTres, 7)}`;
    this.localModel.numeroTres = `${pad(this.localModel.numeroTres, 7)}`;

    let data = Object.assign({}, this.model);

    data.tipoComprobante = { id: data.timbradoDetalle.tipoComprobante.id }
    data.timbradoDetalle = { id: data.timbradoDetalle.id };

    $ngRedux.dispatch(rest.actions.registrarFacturaAnulada({}, {
      body: JSON.stringify(data)
    }, (err, data) => {
      if (!err && data.estado.value == 'Anulada') {
        ngNotify.set(self.translations['Anulada Correctamente'], 'success');
        self.cancel();
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));

  }

  function onSelectTipoComprobante() {
    if (this.localModel.ultimoTibrado && this.model.timbradoDetalle.id === this.localModel.ultimoTibrado.id) {
      return;
    }
    this.localModel.ultimoTibrado = this.model.timbradoDetalle;
    this.model.numeroTimbrado = pad(this.model.timbradoDetalle.cabecera.numero, 8);
    this.model.numeroComprobante = `${pad(this.model.timbradoDetalle.sucursalNumero, 3)}-${pad(this.model.timbradoDetalle.puntoEmision.codigo, 3)}-${pad(this.model.timbradoDetalle.ultimaNumeracion, 7)}`;
    this.localModel.numeroUno = `${pad(this.model.timbradoDetalle.sucursalNumero, 3)}`;
    this.localModel.numeroDos = `${pad(this.model.timbradoDetalle.puntoEmision.codigo, 3)}`;
    this.localModel.numeroTres = this.model.timbradoDetalle.ultimaNumeracion;
  }

  function renderTipoComprobante(timbradoDetalle) {
    return `<div class="tipo-comprobante-factura">${timbradoDetalle.tipoComprobante.nombre} (${timbradoDetalle.tipoComprobante.clase.name} / ${timbradoDetalle.cabecera.claseTimbrado.name} ) <div class="select-detalles"><small>Timbrado: ${pad(timbradoDetalle.cabecera.numero, 8)} - Vigencia: ${fechaRenderer(timbradoDetalle.cabecera.desde)} a ${fechaRenderer(timbradoDetalle.cabecera.hasta)} <small/></div></div>`;
  }

  function renderCliente(cliente) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    return `${cliente.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }

  this.cancel = cancel.bind(this);

  function cancel() {
    $state.go('home.facturas.list');
  }
}


// WEBPACK FOOTER //
// ./src/components/facturas/anular/form.component.js